"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.removeElementById = exports.loadScript = void 0;
var sleep_1 = require("./sleep");
exports.sleep = sleep_1.default;
var defaultLoadScriptRetries = 3;
var maxBackoffSeconds = 60;
var loadScript = function (scriptUrl, callbackOnload, callbackError, retries, attempt) {
    if (callbackOnload === void 0) { callbackOnload = function () { return void (0); }; }
    if (callbackError === void 0) { callbackError = function () { return void (0); }; }
    if (retries === void 0) { retries = defaultLoadScriptRetries; }
    if (attempt === void 0) { attempt = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    var scriptElements, foundScriptElement, scriptElement;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                scriptElements = Array.from(document.getElementsByTagName('script'));
                                foundScriptElement = scriptElements.filter(function (scriptElement) { return scriptElement.src == scriptUrl; });
                                if (!foundScriptElement.length) return [3 /*break*/, 2];
                                return [4 /*yield*/, callbackOnload()];
                            case 1:
                                _a.sent();
                                return [2 /*return*/, resolve()];
                            case 2:
                                scriptElement = document.createElement('script');
                                scriptElement.setAttribute('src', scriptUrl);
                                scriptElement.setAttribute('type', 'text/javascript');
                                document.head.appendChild(scriptElement);
                                scriptElement.addEventListener('load', function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, callbackOnload()];
                                            case 1:
                                                _a.sent();
                                                resolve();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                scriptElement.addEventListener('error', function () { return __awaiter(void 0, void 0, void 0, function () {
                                    var exponentialBackoffWaitTime, e_1;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!(++attempt >= retries)) return [3 /*break*/, 2];
                                                return [4 /*yield*/, callbackError()];
                                            case 1:
                                                _a.sent();
                                                // Reference: https://developer.mozilla.org/en-US/docs/Web/API/Element/error_event
                                                return [2 /*return*/, reject(new Error("Resource failed to load, or can't be used."))];
                                            case 2:
                                                scriptElement.remove();
                                                exponentialBackoffWaitTime = Math.min((Math.pow(2, attempt)) + Math.random(), maxBackoffSeconds) * 1000;
                                                return [4 /*yield*/, sleep_1.default(exponentialBackoffWaitTime)];
                                            case 3:
                                                _a.sent();
                                                _a.label = 4;
                                            case 4:
                                                _a.trys.push([4, 6, , 7]);
                                                return [4 /*yield*/, loadScript(scriptUrl, callbackOnload, callbackError, retries, attempt)];
                                            case 5:
                                                _a.sent();
                                                return [3 /*break*/, 7];
                                            case 6:
                                                e_1 = _a.sent();
                                                reject(e_1);
                                                return [3 /*break*/, 7];
                                            case 7: return [2 /*return*/];
                                        }
                                    });
                                }); });
                                return [2 /*return*/];
                        }
                    });
                }); })];
        });
    });
};
exports.loadScript = loadScript;
var removeElementById = function (id) {
    var _a;
    (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.remove();
};
exports.removeElementById = removeElementById;
exports.default = {
    loadScript: loadScript,
    removeElementById: removeElementById,
    sleep: sleep_1.default
};
//# sourceMappingURL=WebUtils.js.map